import store from '../../../../store';
import lodash from 'lodash';

export const callSearchLookup = ({ criteria }) => store.dispatch(`resource/v1/master/lookup/search`, { criteria });
export const getLabTypeKeyByRoleMenuAttributes = ({ props }) => {
    //const { menuContext } = props;
    const labKeys = [];
    //const { attribute } =  props?.menuContext;
    if (props?.menuContext?.attribute.includes('labMicro')) {
        labKeys.push('labMicro');
    }
    if (props?.menuContext?.attribute.includes('labChemi')) {
        labKeys.push('labChemi');
    }
    if (props?.menuContext?.attribute.includes('labPhysic')) {
        labKeys.push('labPhysic');
    }
    return labKeys;
};
export const strConvertToUnderScore = ({ input }) => {
    if (lodash.isEmpty(input.data)) {
        return '';
    }
    const prefix = input.transform?.prefix || '';
    const suffix = input.transform?.suffix || '';
    if (input.format == 'toLowerCase') {
        return (prefix.toLowerCase() + input.data.split(/(?=[A-Z])/).join('_') + suffix).toLowerCase();
    } else {
        return (prefix.toUpperCase() + input.data.split(/(?=[A-Z])/).join('_') + suffix).toUpperCase();
    }
};

export const getDepartment = ({ searchQuery, where }) => store.dispatch('resource/v1/master/department/cacheFindAll', {
    searchQuery,
    where
});

export const getLabType = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
    group: 'LAB_TYPE',
    value: searchQuery
});
export const getGroupLookupByValue = ({ searchQuery, group }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
    group: group,
    value: searchQuery
});

export const getGroupLookupByKey = ({ searchQuery, group }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
    group: group,
    key: searchQuery
});


export const getLabTypeByKey = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
    group: 'LAB_TYPE',
    key: searchQuery
});

export const getLabTopicByLabTypeKey = ({ searchQuery, labTypeKey,  }) => store.dispatch('resource/v1/master/labTopic/cacheFindAll', {
    searchQuery,
    labTypeKey
});

export const findLabTypeByKey = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', {
    group: 'LAB_TYPE',
    key: searchQuery
}).then(labTypes => {
    return labTypes.find(it => it.key === searchQuery);
});

export const getLabTypeByAttribute = ({ props, data }) => {
    data.labAttributes = getLabTypeKeyByRoleMenuAttributes({ props }) || [];
    if (data.labAttributes.length > 0) {
        return findLabTypeByKey({ searchQuery: data.labAttributes[0] }).then(labType => {
            data.searchLabType = labType;
            data.searchedLabType = true;
            return new Promise(resolve => resolve(data));
        });
    }
    return new Promise(resolve => resolve(data));
};
